import components from './_components';

export default {
    name: 'IssueHeader',
    components,
    props: {
        editable: {
            type: Boolean
        }
    }
};
